import directDebit from "@/services/modules/directDebit";
import $thousandMask from "@/mixins/thousandMask";
import dayjs from "@/utiles/dayjs";

const NumberInput = () => import("@/components/NumberInput/index");
export default {
  name: "createContractForm",
  components: {
    NumberInput
  },
  mixins: [$thousandMask],
  data() {
    return {
      model: {
        mobile: "",
        expiration_months: "",
        max_amount_transaction_per_day: "",
        gateway_id: ""
      },
      contractSetting: null,
      transactionResponse: null,
      chooseItem: JSON.parse(localStorage.getItem("chooseItem")),
      loading: false,
      imidiateChargeLoading: false
    };
  },
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  watch: {
    "model.max_amount_transaction_per_day"(newValue, oldValue) {
      if (newValue) {
        let newNumber = this.removeThousand(newValue);
        let numberLength = newNumber.toString().split(".")[1]
          ? newNumber.toString().split(".")[1].length
          : 0;
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = newValue.replace(".", "");
        if (numberLength && numberLength > 3) {
          this.model.max_amount_transaction_per_day = oldValue;
        } else if (newValue.includes(".")) {
          this.model.max_amount_transaction_per_day = oldValue.replace(".", "");
        }
        if (newNumber[0] === "0") {
          if (newNumber[1] && newNumber[1] !== ".") {
            this.model.max_amount_transaction_per_day = "";
          }
        } else if (withoutDot.includes(".")) {
          this.model.max_amount_transaction_per_day = oldValue;
        } else if (!isPositiveNumbers(newValue)) {
          this.model.max_amount_transaction_per_day = oldValue;
        }
      }
    }
  },
  mounted() {
    this.getGateways();
    // this.model.max_amount_transaction_per_day = this.chooseItem
    // .max_amount_transaction_per_day.remains
    // ? this.chooseItem.max_amount_transaction_per_day.remains
    // : this.chooseItem.max_amount_transaction_per_day;
    this.model.gateway_id = this.chooseItem.id;
  },
  methods: {
    createContract() {
      this.model.max_amount_transaction_per_day = this.removeThousand(
        this.model.max_amount_transaction_per_day
      );
      this.loading = true;
      directDebit
        .createContract(this.model)
        .then(res => {
          window.location.href = res.data.data.redirect_url;
        })
        .finally(() => (this.loading = false));
    },
    createTransaction() {
      let data = {
        amount: this.removeThousand(this.model.max_amount_transaction_per_day),
        contract_id: this.chooseItem.id
      };
      this.imidiateChargeLoading = true;
      directDebit
        .createTransaction(data)
        .then(res => {
          this.transactionResponse = res.data.data[0];
        })
        .finally(() => (this.imidiateChargeLoading = false));
    },
    getGateways() {
      directDebit.getAllGateways().then(res => {
        this.contractSetting = res.data.data.contract_setting.expiration_months;
      });
    },
    removeThousand(value) {
      const str = value.toString();
      return str.replace(/,/gi, "");
    },
    cancelOrder() {
      this.$emit("changeMode", "firstSection");
    },
    handleInput({ target: { value } }) {
      if (!this.maximumDeposit) {
        const set = amount => {
          let enDigits = this.toEnglishDigits(amount);
          let noComma = this.removeThousand(enDigits);
          let zeroLead = this.leadingZero(noComma);
          let amountMask = this.$thousandMask(zeroLead);
          this.model.max_amount_transaction_per_day = noComma ? amountMask : 0;
        };
        set(value);
      } else {
        const set = amount => {
          let enDigits = this.toEnglishDigits(amount);
          let noComma = this.removeThousand(enDigits);
          let zeroLead = this.leadingZero(noComma);
          let amountMask = this.$thousandMask(zeroLead);
          this.maxDepositAmount = noComma ? amountMask : 0;
        };
        set(value);
      }
    },
    toEnglishDigits(value) {
      const persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return value
        .toString()
        .replace("٫", ".")
        .replace(/[۰-۹]/g, chr => {
          return persian.indexOf(chr);
        });
    },
    leadingZero(value) {
      let number = value.toString();
      if (value.includes(".")) {
        while (number.charAt(0) === "0" && number.charAt(1) !== ".") {
          number = number.substring(1);
        }
      } else if (number.slice(-1) !== "0") {
        while (number.charAt(0) === "0") {
          number = number.substring(1);
        }
      }
      return number;
    }
  }
};
